import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import React from "react";

const MySwal = withReactContent(Swal);


export const showDialogCustomizable = (
  content: React.ReactNode,
  title = "",
  confirmButtonText = "",
  cancelButtonText = "",
  onConfirm?: () => void,
  showConfirmButton = false,
  width = '60%'
) => {
  MySwal.fire({
    title: title,
    html: <div>{content}</div>,
    showCancelButton: false,
    showConfirmButton: showConfirmButton,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    width: width,            // larghezza personalizzata
    allowOutsideClick: false, // blocca click fuori
    allowEscapeKey: false,    // blocca ESC
    customClass: {
      popup: "my-swal-popup",
    },
    didOpen: () => {
      MySwal.update({});
    },
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    }
  });
};




